import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import SlotifyLogo from "@/components/SlotifyLogo";
import { useLanguage } from "@/contexts/LanguageContext";

const TermsConditions = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2">
            <SlotifyLogo className="h-7" />
          </Link>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t("legal.back_home")}
            </Link>
          </Button>
        </div>
      </header>

      <main className="container mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">{t("legal.terms_title")}</h1>
        <p className="text-sm text-muted-foreground mb-8">{t("legal.last_updated")}: 15 February 2026</p>

        <div className="prose prose-sm max-w-none text-foreground space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.acceptance_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.acceptance_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.service_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.service_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.accounts_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.accounts_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.payment_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.payment_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.ip_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.ip_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.liability_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.liability_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.termination_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.termination_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.changes_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.changes_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("terms.governing_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.governing_text")}</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsConditions;
